export * from './rbac-permission.facade';
